<template>
  <div v-if="ativo == true" class="selecao_uf_mobile">
    <span>Escolha uma UF:</span>
    <ul class="ufs-mobile">
      <a href="javascript:void(0)" v-for="(item, idx) in siglas" :key="idx" @click="changeUF(item)">
        {{ item }}
      </a>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SelectUFMobile',
  props: {
    ativo: {
      type: Boolean,
      default: false,
    },
  },
  computed: mapGetters({
    uf: 'user/uf',
    siglas: 'user/ufSiglas',
  }),
  methods: {
    ...mapActions({
      changeUF: 'user/changeUF',
    }),
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

a {
  text-decoration: none;
}

.selecao_uf_mobile {
  // @extend %flex;
  // @extend %direction-row;
  // @extend %justify-start;
  // @extend %align-items-start;
  @extend %gradiente_twilight;
  // @extend %flex-wrap;
  color: white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5001;
  height: calc(100vh - 160px);
  padding: 85px 10px 75px 30px;
  margin: 0px;
  width: 100%;
  max-width: calc(70% - 10px);

  & span {
    color: $cor_amarelo;
    font-size: 16px;
  }

  .ufs-mobile {
    @extend %flex;
    @extend %direction-row;
    @extend %flex-wrap;
    @extend %justify-start;
    @extend %align-items-start;
    width: 100%;
    padding: 0px;

    & a {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #ffffff33;
      border-radius: 5px;
      margin: 0 5px 5px 0;
      padding: 0px !important;
      width: 7vh;
      height: 7vh;
      font-size: 14px;
      font-family: 'OpenSans';
      font-weight: 500;
      color: white;
      text-align: center;
      border-radius: 3px !important;

      &:hover {
        background-color: $cor_amarelo;
        border-radius: 5px;
        font-family: 'OpenSans';
        font-weight: bold;
      }
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .selecao_uf_mobile {
    padding: 115px 20px 75px 50px;
    max-width: calc(70% - 100px);

    & span {
      font-size: 24px;
    }

    & .ufs-mobile {
      & a {
        font-size: 20px;
      }
    }
  }
}
</style>
